package com.essntl.core.stripe.domain.models

data class Product(
    val id: String,
)
